/** 逻辑 field key，供 accessPolicy / registerCapability.fields 使用 */
export const RUN_POLICY_FIELD_KEYS = {
  strategy: 'runPolicy.strategy',
} as const;

export const RUN_POLICY_FIELD_KEY_LIST = [RUN_POLICY_FIELD_KEYS.strategy] as const;
